/**
 * Safely extract a human-readable error message from an Axios error.
 * FastAPI returns validation errors as arrays in `detail`, which crashes
 * React if rendered directly. This helper normalises all shapes to a string.
 */
export function extractErrorMessage(err, fallback = 'An error occurred') {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail) && detail.length > 0) return detail[0]?.msg || fallback;
  return err?.message || fallback;
}
